import dayjs from 'dayjs';

const ANNUAL_PLAN_PRICE = 4999;
const ANNUAL_PLAN_TYPE = 'annually';
const ANNUAL_PLAN_NAME = `saral-${ANNUAL_PLAN_PRICE}-${ANNUAL_PLAN_TYPE}`;

const MONTHLY_PLAN_DEFAULT_PRICE = 499;
const MONTHLY_PLAN_TYPE = 'monthly';

const QUARTERLY_PLAN_DEFAULT_PRICE = 1197;
const QUARTERLY_PLAN_TYPE = 'quarterly';

const BASE_PLAN_RATNA = 300;

const ANNUAL_PLAN_PRICING_TITLE = 'Annual Plan';
const DISCOUNTED_PLAN_PRICING_TITLE = 'Special Startup Pricing';
const BASE_PLAN_PRICING_TITLE = `Exclusive ${dayjs().format('YYYY')} Price`;

const ANNUAL_PLAN_PRICING_DESCRIPTION =
  'You are now on the annual plan! Your feature requests will be prioritized and you will receive special consulting & support. Thank you for your trust. Don’t hesitate to reach out.';
const DISCOUNTED_PLAN_PRICING_DESCRIPTION =
  'You are on a special startup plan. If you need any help with the growth of your influencer program. Please reach out to us in support. Feel free to send us your feature requests!';
const BASE_PLAN_PRICING_DESCRIPTION =
  "Thanks for your trust. We increase prices every few months with more features, but you're forever locked in at this price!";

const VALID_SUBSCRIPTION_STATUS = [
  'free',
  'active',
  'pause',
  'cancelled',
  'past_due',
  'trial',
  'trial_ended',
  'deleted',
  'preserve',
];

const PLAN_COSTS = {
  monthly: { 100: 249, 300: 499, 500: 699, 1200: 999, 2000: 1499, 3000: 1999 },
  quarterly: { 100: 597, 300: 1197, 500: 1677, 1200: 2397, 2000: 3597, 3000: 4797 },
  annually: { 300: 4999, 500: 6999, 1200: 9999, 2000: 14999, 3000: 19999 },
};

const SUBSCRIPTION_STATUS_ENUM = {
  cancelled: 'cancelled',
  active: 'active',
  past_due: 'past_due',
  trial: 'trial',
  trial_ended: 'trial_ended',
  free: 'free',
  preserve: 'preserve',
  blocked: 'blocked',
  pause: 'pause',
};

const SUBSCRIPTION_PLAN_DETAILS = {
  STARTER: {
    name: 'Starter',
    ratnaCount: 300,
    activePartnerships: 100,
    seatsLimit: 1,
  },
  BUSINESS: {
    name: 'Business',
    ratnaCount: 800,
    activePartnerships: 500,
    seatsLimit: 3,
  },
  PROFESSIONAL: {
    name: 'Professional',
    ratnaCount: 2000,
    activePartnerships: 1000,
    seatsLimit: 10,
  },
};

const ACTIVE_PARTNERSHIP_REACHED_ERROR_CODE = 'ACTIVE_PARTNERSHIPS_LIMIT_REACHED';

export {
  ANNUAL_PLAN_PRICE,
  ANNUAL_PLAN_TYPE,
  ANNUAL_PLAN_NAME,
  MONTHLY_PLAN_DEFAULT_PRICE,
  MONTHLY_PLAN_TYPE,
  QUARTERLY_PLAN_DEFAULT_PRICE,
  QUARTERLY_PLAN_TYPE,
  BASE_PLAN_RATNA,
  ANNUAL_PLAN_PRICING_TITLE,
  DISCOUNTED_PLAN_PRICING_TITLE,
  BASE_PLAN_PRICING_TITLE,
  ANNUAL_PLAN_PRICING_DESCRIPTION,
  DISCOUNTED_PLAN_PRICING_DESCRIPTION,
  BASE_PLAN_PRICING_DESCRIPTION,
  VALID_SUBSCRIPTION_STATUS,
  PLAN_COSTS,
  SUBSCRIPTION_STATUS_ENUM,
  SUBSCRIPTION_PLAN_DETAILS,
  ACTIVE_PARTNERSHIP_REACHED_ERROR_CODE
};
